var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "touchpoint-overview-row",
    { staticClass: "info-row-header" },
    [
      _vm.displaySource
        ? _c("template", { slot: "left" }, [
            _c(
              "div",
              { staticClass: "info-row-header-cell d-flex" },
              [
                _c("touchpoint-overview-icon-circle", {
                  staticClass: "info-circle mr-2",
                  attrs: { color: "blue" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "info-row-header-text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.resource(
                        "TouchpointStatistics_Header_PreviousTouchpoint"
                      )
                    )
                  )
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.displaySelected
        ? _c("template", { slot: "center" }, [
            _c(
              "div",
              { staticClass: "info-row-header-cell" },
              [
                _c("touchpoint-overview-icon-magic"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticClass: "info-row-header-text" }, [
                  _vm._v(
                    _vm._s(
                      _vm.resource("TouchpointStatistics_Header_SelectedNumber")
                    )
                  )
                ])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.displayDestination
        ? _c("template", { slot: "right" }, [
            _c(
              "div",
              { staticClass: "info-row-header-cell d-flex flex-row-reverse" },
              [
                _c("touchpoint-overview-icon-circle", {
                  staticClass: "info-circle",
                  attrs: { color: "green" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "info-row-header-text mr-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm.resource(
                        "TouchpointStatistics_Header_ArrivedAtTouchpoint"
                      )
                    )
                  )
                ])
              ],
              1
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }